import { Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { ControlesLinha, ProcessoInput } from '../../components/RelatorioCivelComponents';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step07RazoesFinais(props: RelatorioCivelStepProps) {
  const {
    novoProcessoRazoesFinais,
    setNovoProcessoRazoesFinais,
    adicionarProcesso,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    renderTabelaProcessos,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <ProcessoInput
                value={novoProcessoRazoesFinais}
                onChange={setNovoProcessoRazoesFinais}
                onAdicionar={() =>
                  adicionarProcesso('razoesFinais', novoProcessoRazoesFinais, setNovoProcessoRazoesFinais)
                }
              />
              <Form.Text className="text-muted">
                Pressione Enter ou clique em Adicionar para incluir o processo na lista
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      )}

      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas.razoesFinais}
          onDecrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, razoesFinais: Math.max(1, prev.razoesFinais - 1) }))
          }
          onIncrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, razoesFinais: Math.min(50, prev.razoesFinais + 1) }))
          }
          onQuantidadeChange={(value: number) => setQuantidadeLinhas((prev) => ({ ...prev, razoesFinais: value }))}
          onAdicionar={() => adicionarMultiplasLinhas('razoesFinais')}
          totalLabel="Total de Processos"
          totalCount={formData.razoesFinais.processos.length}
        />
      )}

      {renderTabelaProcessos('razoesFinais', formData.razoesFinais.processos)}
    </Fragment>
  );
}

